<template>
<el-scrollbar>
  <div class="page" ref="pageRef" @scroll.passive="handleScroll">
    <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-bottom: 0;">
      <span>待复核补贴报单列表</span>
      <span></span>
    </div>
    <div class="shadow-box">
      <div class="page-main_box" style="height: auto;">
        <div class="search-box" style="padding-top: 6px;">
          <el-row :gutter="12" style="padding-bottom: 8px;">
            <el-col :span="5">
              <div class="search-item">
                <div class="label">订单编号：</div>
                <el-input type="textarea" :rows="1" v-model="form.thirdOrderSn" @blur="goSearch" @clear="goSearch" clearable placeholder="多个编号使用换行"></el-input>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="search-item">
                <div class="label">商品名称：</div>
                <el-input v-model="form.goodsName" @blur="goSearch" @clear="goSearch" clearable placeholder="请输入商品名称"></el-input>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="search-item">
                <div class="label">报单时间：</div>
                <el-date-picker
                  v-model="form.reportDate"
                  style="flex: 1;"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="false"
                  :picker-options="reportDateOptions"
                  @change="goSearch">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="search-item">
                <div class="label">付款时间：</div>
                <el-date-picker
                  v-model="form.orderPayTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="flex: 1;"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="goSearch">
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="12">
            <el-col :span="5">
              <div class="search-item">
                <div class="label">收货时间：</div>
                <el-date-picker
                  v-model="form.orderReceiveTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="flex: 1;"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="goSearch">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="search-item">
                <div class="label">报单状态：</div>
                <!-- 1-已跟单,2-已丢单,3-已返款 -->
                <el-select clearable style="width: 100%;" v-model="form.reportStatus" @change="goSearch" placeholder="选择状态">
                  <el-option :value="''" label="全部"></el-option>
                  <el-option :value="1" label="已跟单"></el-option>
                  <el-option :value="2" label="已丢单"></el-option>
                  <el-option :value="3" label="已返款"></el-option>
                </el-select>
              </div>
            </el-col>

          <!-- 1 超管 --> 
          <template v-if="roleType == 1">
            <el-col :span="5">
              <div class="search-item">
                <div class="label">一级账号：</div>
                <el-select clearable filterable style="width: 100%;" v-model="form.parentQdAccountId" @change="oneQdChange" placeholder="请选择">
                  <el-option v-for="item in groupList1"
                  :key="item.accountId"
                  :value="item.accountId"
                  :label="item.nickName"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="search-item">
                <div class="label">二级账号：</div>
                <el-select clearable filterable style="width: 100%;" :disabled="!form.parentQdAccountId" v-model="form.qdAccountId" @change="goSearch" placeholder="请选择">
                  <el-option v-for="item in groupList2"
                  :key="item.accountId"
                  :value="item.accountId"
                  :label="item.nickName"></el-option>
                </el-select>
              </div>
            </el-col>
          </template> 

          <!-- 一级 --> 
          <template v-if="roleType == 3"> 
            <el-col :span="5">
            <div class="search-item">
              <div class="label">二级账号：</div>
              <el-select clearable style="width: 100%;" v-model="form.qdAccountId" @change="goSearch" placeholder="请选择">
                <el-option v-for="item in groupList2"
                :key="item.accountId"
                :value="item.accountId"
                :label="item.nickName"></el-option>
              </el-select>
            </div>
          </el-col>
          </template> 
          <!-- <el-col :span="5">
            <div class="search-item">
              <div class="label">订单类型：</div>
              <el-select clearable style="width: 100%;" v-model="form.reportTypeList" @change="goSearch" placeholder="选择类型">
                <el-option :value="''" label="全部"></el-option>
                <el-option value="QD" label="渠道订单"></el-option>
                <el-option value="BT" label="补贴订单"></el-option>
                <el-option value="ZS" label="专属订单"></el-option>
              </el-select>
            </div>
          </el-col> -->

            <el-button type="primary" @click="goSearch">查 询</el-button>
          </el-row>
        </div>

        <!-- 超管 / 一级 -->
        <div class="summary-line flex-row flex-main-axis-between" style="padding-bottom: 10px;">
          <div>
            <el-button type="primary" v-if="roleType !== 1" @click="showAddReportHandler">新增报单</el-button>
            <el-button type="primary" :disabled="!multipleSelection.length" @click="showBatchDialogHandler">批量返款</el-button>
            <el-button type="primary" :disabled="pageInfo.total === 0" @click="getAllList"
              icon="el-icon-download"
              :loading="downloadLoading"
            >导出</el-button>
            <el-button v-if="roleType == 1" type="primary" @click="showImportDeleteDialog = true">导入删除</el-button>
            <el-button v-if="roleType !== 1" type="primary" @click="showImportExportDialog = true">导入查单</el-button>
          </div>

          <div class="summary-line" v-if="roleType === 1">
            跟单订单数：<b class="primary-color">{{ summaryData.orderCount || 0 }}</b>  &nbsp;   跟单订单金额：<b class="primary-color">{{summaryData.orderAmount | filterAmount}}</b>  &nbsp;  跟单支出总佣金：<b class="primary-color">{{ summaryData.promotionAmount | filterAmount }}</b>
          </div>
          <div class="summary-line" v-if="roleType === 3">
            跟单订单数：<b class="primary-color">{{ summaryData.orderCount || 0 }}</b>  &nbsp; 跟单订单金额：<b class="primary-color">{{summaryData.orderAmount | filterAmount}}</b>  &nbsp; 
            <template v-if="isXiaomi">订单总佣金：<b class="primary-color">{{ computedRebatePromotionAmount(summaryData)}}</b></template>
            <template v-else>跟单佣金：<b class="primary-color">{{ summaryData.promotionAmount | filterAmount }}</b></template>
          </div>
          <div class="summary-line" v-if="roleType === 2">
            跟单订单数：<b class="primary-color">{{ summaryData.orderCount || 0 }}</b>  &nbsp;     跟单订单金额：<b class="primary-color">{{summaryData.orderAmount | filterAmount}}</b>  &nbsp;
          </div>
        </div>

        <div class="code-list-content" ref="tableContainer">
          <!-- <div class="table-collapse">
            <div class="icon-box" @click="columnShow = !columnShow; tableKey++">
              <span class="primary-color" v-if="!columnShow">更多</span>
              <img class="icon" src="../../../../../../assets/images/c-left.png" v-if="columnShow" />
              <img class="icon" src="../../../../../../assets/images/c-right.png" v-else />
            </div>
          </div> -->
          <el-table
            class="y-table"
            border
            stripe 
            v-if="roleType"
            :key="tableKey"
            ref="multipleTable"
            style="width: calc(100vw - 256px);"
            v-bind="heightAttr"
            :data="tableData"
            @selection-change="handleSelectionChange"
            v-loading="isLoading"
          >
          <!--  -->
            <el-table-column
              fixed
              type="selection"
              :selectable="selectableRow"
              width="45">
            </el-table-column>

            <el-table-column
              label="补贴政策"
              width="100">
              <template slot-scope="{ row }">
                <span>
                  <el-button @click="showQueryBdRebateInfo(row)" type="text">选择补贴政策</el-button>
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="orderId"
              fixed
              label="订单号"
              width="80">
            </el-table-column> -->
            <el-table-column
              prop="thirdOrderSn"
              label="订单编号"
              width="70"> 
            </el-table-column>

            <el-table-column
              prop="orderStatus"
              label="订单状态"
              width="70"> 
              <template slot-scope="{ row }">
                <div>
                  {{ row.orderStatus | filterOrderStatus }}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="type"
              label="第三方平台"
              width="90">
              <template slot-scope="{ row }">
                <div>{{ row.type | filterThirdType }}</div>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="realGoodsId"
              label="商品ID"
              min-width="60">
              <template slot-scope="{ row }">
                <div>{{ row.realGoodsId }}
                  <span v-if="row.type">({{ row.type | filterThirdType }})</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="goodsThumbnailUrl"
              label="商品主图"
              width="96">
              <template slot-scope="{ row }">
                <div>
                  <el-image
                    v-if="row.goodsThumbnailUrl"
                    shape="square"
                    :preview-src-list="[row.goodsThumbnailUrl]"
                    style="width: 80px; height: 80px;"
                    fit="cover" :src="row.goodsThumbnailUrl"></el-image>
                  <span v-else>--</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goodsName"
              label="商品名称"
              min-width="80">
            </el-table-column>
            <!-- 单位为 分 -->
            <el-table-column
              prop="orderAmount"
              label="商品金额"
              width="70">
              <template slot-scope="{ row }">
                <div>{{ row.orderAmount | filterAmount }}</div>
              </template>
            </el-table-column>
            <!-- 十万分比 -->
            <el-table-column
              prop="promotionRate"
              label="佣金比例"
              width="100">
              <template slot-scope="{ row }">
                <div class="table-cell">
                  <!-- 佣金比 -->
                  <div class="table-line">{{ row | filterPromotionRate}}</div>
                  <!-- 补贴佣金比例 -->
                  <!-- <div class="table-line title" v-if="isXiaomi">补贴佣金比例</div>
                  <div class="table-line" v-if="isXiaomi">{{ (row.subsidyPromotionRate !== null && row.subsidyPromotionRate !== undefined) ? ((row.subsidyPromotionRate || 0) * 100).toFixed(2) + '%' : '--' }}</div>
                  <div class="table-line title red-bg" v-if="isXiaomi">结算佣金比例</div>
                  <div class="table-line red-bg" v-if="isXiaomi">
                    {{ row | filterTotalPromotionRate }}
                  </div> -->
                </div>
              </template>
            </el-table-column>
            <!-- 单位为分 -->
            <el-table-column
              prop="promotionAmount"
              label="佣金金额"
              width="100">
              <template slot-scope="{ row }">
                <div class="table-cell">
                  <div class="table-line">{{ row.promotionAmount | filterAmount }}</div>
                  <!-- <div class="table-line title" v-if="isXiaomi">补贴佣金金额</div>
                  <div class="table-line" v-if="isXiaomi">{{ row.subsidyAmount | filterAmount}} </div>
                  <div class="table-line title red-bg" v-if="isXiaomi">结算佣金金额</div>
                  <div class="table-line red-bg" v-if="isXiaomi">{{ row | filterTotalAmount }}</div> -->
                </div>
              </template>
            </el-table-column>

            <!-- 订单总佣金 -->
            <!-- <el-table-column
              label="订单总佣金"
              v-if="isXiaomi"
              width="85">
              <template slot-scope="{ row }">
                <div>{{ row | filterDdzyj }}</div>
              </template>
            </el-table-column> -->
            <!-- 补贴描述 -->
            <!-- <el-table-column
              prop="rebateInfoType"
              v-if="isXiaomi"
              label="佣金比例描述"
              width="95">
              <template slot-scope="{ row }">
                <div>{{ row.rebateInfoType | filterRebateInfoType }}</div>
              </template>
            </el-table-column> -->

            <el-table-column
              prop="reportTime"
              label="报单时间"
              width="100">
              <template slot-scope="{ row }">
                <div class="table-cell">
                  <el-tooltip :disabled="!row.reportTime" :content="computedDate(row.reportTime)">
                    <div class="table-line">
                      {{ row.reportTime | filterDate }}
                    </div>
                  </el-tooltip>
                  <div class="table-line title">付款时间</div>
                  <el-tooltip :disabled="!row.orderPayTime" :content="computedDate(row.orderPayTime)">
                    <div class="table-line">{{ row.orderPayTime | filterDate }} </div>
                  </el-tooltip>
                
                  <div class="table-line title">收货时间</div>
                  <el-tooltip :disabled="!row.orderReceiveTime" :content="computedDate(row.orderReceiveTime)">
                    <div class="table-line">
                      {{ row.orderReceiveTime | filterDate }}
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <!-- * 一级渠道报单状态 1-已跟单,2-已丢单,3-已返款 -->
            <el-table-column
              prop="qdReportStatus"
              label="报单状态"
              width="70">
              <template slot-scope="{ row }">
                <div class="status-text">
                  <!-- 1-超管 2-二级渠道 3-一级渠道 -->
                  <!-- 超管 -->
                  <div v-if="roleType == 1" v-html="filterReportStatus(row.qdReportStatus)"></div>
                  <!-- 一级账号 -->
                  <div v-else-if="roleType == 3" v-html="filterReportStatus(row.qdSubReportStatus)"></div>
                  <div v-else-if="roleType == 2" v-html="filterReportStatus(row.clientReportStatus)"></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="reportSource"
              label="报单入口"
              width="96">
              <template slot-scope="{ row }">
                  <div class="table-cell">
                    <div class="table-line">{{ row.reportSource || '-' }}</div>
                    <div class="table-line title">报单用户</div>
                    <el-tooltip :content="row.reportAccountName" :disabled="row.reportAccountName && row.reportAccountName.length < 6">
                      <div class="table-line">
                          {{ row.reportAccountName || '-' }}
                      </div>
                    </el-tooltip>
                  </div>
              </template>
            </el-table-column>
            <!-- 
              v-if="roleType !== 2" -->
            <el-table-column
              prop="parentQdAccountName"
              label="归属渠道"
              width="120">
              <template slot-scope="{ row }">
                <div class="table-cell">
                  <div class="table-line">{{ row.parentQdAccountName || '-' }}</div>
                  <div class="table-line title">归属二级渠道</div>
                  <el-tooltip :content="row.qdAccountName" :disabled="row.qdAccountName && row.qdAccountName.length < 6">
                    <div class="table-line">
                        {{ row.qdAccountName || '-' }}
                    </div>
                  </el-tooltip>
                </div>
              </template> 
            </el-table-column>
            <!-- <el-table-column
              prop="commissionValidStatus"
              label="佣金状态"
              width="120">
              <template slot-scope="{ row }">
                <div>
                  <span v-if="row.commissionValidStatus === '有效'" style="color: #1990FF;">有效</span>
                  <span v-else-if="row.commissionValidStatus === '无效'" style="color: #FF9F19;">无效</span>
                  <span v-else>{{ row.commissionValidStatus }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="收入佣金"
              v-if="columnShow && roleType && roleType != 1"
              width="80">
              <template slot-scope="{ row }"> 
                <div v-if="roleType == 3">
                  {{ row.qdCommissionIncomeStatus | filterIncomeStatus }}
                </div>
                <div v-if="roleType == 2">
                  {{ row.qdSubCommissionIncomeStatus | filterIncomeStatus }}
                </div>
              </template>
            </el-table-column> 
          <el-table-column
            v-if="columnShow"
              prop="commissionAmount"
              label="用户返利"
              width="80">
              <template slot-scope="{ row }">
                <div>{{ row.commissionAmount | filterAmount }}</div>
              </template>
            </el-table-column>

            <el-table-column
              v-if="columnShow"
              prop="commissionValidReason"
              label="佣金无效原因"
              width="120">
            </el-table-column> -->
          </el-table>
          <div class="bd--pag flex-row flex-main-axis-between">
            <div v-if="roleType == 1">
              <span style="color: #999; font-size: 12px; padding-right: 12px;">共勾选 <b>{{ multipleSelection.length }}</b> 条数据</span>
              <el-button @click="batchDelHandler" :disabled="!multipleSelection.length">批量删除</el-button>
            </div>
            <div v-else></div>

            <el-pagination
              v-if="pageInfo.total > 0"
              class="d-ib"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageInfo.total"
              :page-sizes="pageInfo.sizes"
              :page-size="pageInfo.size"
              :current-page="pageInfo.current"
              @current-change="pageInfo.current = arguments[ 0 ], getList()"
              @size-change="pageInfo.size = arguments[ 0 ], getList()">
            </el-pagination>
          </div> 
        </div>
      </div>

      <!-- 批量返款 -->
      <RefundBatchDialog
        v-if="showBatchDialog"
        v-model="showBatchDialog"
        :list="multipleSelection"
        :roleType="roleType"
        @close="showBatchDialog = false"
        @on-success="successHandler"
      ></RefundBatchDialog>

      <!-- 新增 -->
      <AddReportDialog
        v-if="showAddReportDialog"
        v-model="showAddReportDialog"
        :roleType="roleType"
        reportType="ZS"
        @check-result="checkResultCb"
        @close="showAddReportDialog = false"
        @on-success="showAddResultDialogHandler"
      />

      <!-- 检查结果弹框 -->
      <CheckResultDialog
        v-if="showCheckResultDialog"
        v-model="showCheckResultDialog"
        :rst="checkResult"
        @close="showCheckResultDialog = false" />

      <!-- 导入查询 -->
      <ImportExportDialog
        v-if="showImportExportDialog"
        v-model="showImportExportDialog" 
        reportType="ZS"
        :roleType="roleType"
        @close="showImportExportDialog = false"
        @on-success="showImportExportDialog = false"
      />
      <!-- 导入删除 -->
      <ImportDeleteDialog
        v-if="showImportDeleteDialog"
        v-model="showImportDeleteDialog" 
        @close="showImportDeleteDialog = false"
        @on-success="showImportDeleteDialog = false"
      />

      <AddResultDialog
        v-if="showAddResultDialog"
        v-model="showAddResultDialog"
        reportType="ZS"
        :roleType="roleType"
        @close="showAddResultDialog = false; importResult = {}"
        :importResult="importResult"
        @on-success="addReportSuccessHandler"
      />

      <ZcListDialog
        v-if="showQueryBdRebateInfoDialog"
        v-model="showQueryBdRebateInfoDialog"
        :rebateInfo="rebateInfo"
        @close="showQueryBdRebateInfoDialog = false"
        @on-success="getList(); showQueryBdRebateInfoDialog = false;"
      />
    </div>
  </div>
</el-scrollbar>
</template>
<script>
import RefundBatchDialog from '@/page/component/sections/order/refund-batch-dialog.vue'
import AddReportDialog from '@/page/component/sections/order/add-report-dialog.vue'
import AddResultDialog from '@/page/component/sections/order/add-result-dialog.vue'
import CheckResultDialog from '@/page/component/sections/order/check-result-dialog.vue'
import ImportExportDialog from '@/page/component/sections/order/import-export-dialog.vue'
import ImportDeleteDialog from '@/page/component/sections/order/import-delete-dialog.vue'
import ZcListDialog from '@/page/component/sections/order/zc-list-dialog.vue'
import {
  getAccountRoleType,
  queryExportOrderReportWeb,
  queryOrderReportSum,
  removeOrderReportWeb
} from '@/service/apis/order'
// import { getParentAccountId, getAccountId } from '@/directives/permission'
import { douyinM2SPageList } from '@/service/apis/group'
import moment from 'moment'
import { throttle } from 'lodash'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { getZsFields, typeMap, getOrderStatus, moneyFormatFn, computedPromotionRate, computedPromotionRateValue, rebateInfoTypes, toFixed1 } from '@/page/component/routes/index/order-manage/order-list/fields'
import { getUserId } from '@/utils/getUser' 
import NP from 'number-precision' 
const dayjs = require('dayjs')

export default {
  components: { 
    RefundBatchDialog,
    AddReportDialog,
    ImportExportDialog,
    ImportDeleteDialog,
    AddResultDialog,
    CheckResultDialog,
    ZcListDialog
   },
   computed: {
    fields () {
      return getZsFields(this.roleType)
    },
    // 一级账号 可见 || 小米的二级账号
    isXiaomi () {
      // return this.roleType === 3 || (getParentAccountId() == 2576247038583552 && this.roleType == 2)
      // return getAccountId() == '2576247038583552' // 小米
      return true // 放开所有
    }
  },
  data () {
    return {
      reportDateOptions: this.createPickerOptions(),
      heightAttr: {},
      tableKey: 0,
      downloadLoading: false,
      allList: [],
      columnShow: false,
      form: {
        thirdOrderSn: '',
        goodsName: '',
        reportDate: [
          moment().subtract(30, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        orderPayTime: [],
        orderReceiveTime: [],
        reportStatus: '',
        incomeStatus: '',
        parentQdAccountId: '', // 一级账号,
        qdAccountId: '', // 二级账号
        reportTypeList: ''
      },
      curTab: '',
      pageInfo: {
        current: 1,
        size: 10,
        sizes: [ 10, 20, 30, 50, 100 ],
        pages: 0,
        total: 0
      },
      // 1-超管 2-二级渠道 3-一级渠道
      roleType: null,
      isLoading: false,
      tableData: [],
      editRow: null, 
      showBatchDialog: false,
      showReportSum: false,
      summaryData: {},
      multipleSelection: [],
      showAddReportDialog: false,
      groupList1: [],
      groupList2: [],
      importResult: {},
      showAddResultDialog: false,
      tableContainerTop: null,
      showImportExportDialog: false,
      showImportDeleteDialog: false,
      checkResult: null,
      showCheckResultDialog: false,
      showQueryBdRebateInfoDialog: false,
      rebateInfo: null
    }
  },
  filters: {
    filterThirdType (type) {
      return typeMap[type] || '--'
    },
    filterDate (date) {
      if (date) {
        // return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
        return dayjs(date).format('YYYY-MM-DD')
      }
      return '--'
    },
    filterRebateInfoType (type) {
      return rebateInfoTypes[type] || '--'
    },
    filterAmount (amount) {
      return moneyFormatFn(amount) || '--'
    },
    filterTotalAmount (row) {
      const promotionAmount = row.promotionAmount
      const subsidyAmount = row.subsidyAmount
      let total = promotionAmount === null && subsidyAmount === null ? '--' : moneyFormatFn((promotionAmount || 0) + (subsidyAmount || 0))
      if (total === '--') {
        return '--'
      } else {
        return toFixed1(total)
      }
    },
    filterDdzyj (row) {
      // 佣金 promotionAmount+补贴佣金 subsidyAmount
      return moneyFormatFn((row.promotionAmount || 0) + (row.subsidyAmount || 0))
    },
    filterPromotionRate (row) {
      return computedPromotionRate(row) || '--'
    },
    filterTotalPromotionRate (row) {
      // 佣金比 + 补贴佣金比例
      const PromotionRate = computedPromotionRateValue(row)
      const subsidyPromotionRate = (row.subsidyPromotionRate !== null && row.subsidyPromotionRate !== undefined) ? (row.subsidyPromotionRate || 0) * 100 :  ''
      if (subsidyPromotionRate === '' && PromotionRate === '') {
        return '--'
      }
      let total = NP.plus(PromotionRate || 0, subsidyPromotionRate || 0)
      total = toFixed1(total)
      return total + '%'
    },
    filterIncomeStatus (status) { 
      // 1是已返 0是未返
      return status == 1 ? '已返' :
        status == 0 ? '未返' : '--'
    },
    filterOrderStatus (status) {
      return getOrderStatus(status) || '--'
    }
  },
  async created () {
    // 获取角色
    await this.getAccountRoleType()

    this.$nextTick(() => {
      this.getList()
      // 汇总数据
      this.queryOrderReportSum()
    })
  },
  mounted() {
    this.$nextTick(() => { 
      // window.addEventListener('scroll', this.handleScroll);
      this.$refs.scrollContainer && this.$refs.scrollContainer.addEventListener(
        'scroll',
        this.handleScroll,
        { passive: true }
      )
    })
  },
  beforeDestroy() {
    // 移除滚动事件监听器
    // window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    createPickerOptions() {
      const self = this
      return {
        onPick: (date) => {
          // 当选择了一个日期时，记录该日期
          if (date.minDate && !date.maxDate) {
            self.tempSelectedDate = date.minDate;
          } else {
            self.tempSelectedDate = null;
          }
        },
        disabledDate: (time) => {
          // 如果没有已选择的日期，则不禁用
          if (!self.tempSelectedDate) {
            return false;
          }
          
          // 超管限制一个月，其他6个月
          const sixMonths = this.roleType === 1 ? 30 * 24 * 60 * 60 * 1000 : 180 * 24 * 60 * 60 * 1000;
          
          // 限制可选日期在已选日期的前后6个月内
          return Math.abs(time.getTime() - self.tempSelectedDate.getTime()) > sixMonths;
        }
      };
    },
    showQueryBdRebateInfo (row) {
      this.rebateInfo = row
      this.showQueryBdRebateInfoDialog = true
    },
    checkResultCb(rst) {
      console.log('checkResult', rst)
      this.checkResult = rst
      this.showAddReportDialog = false
      this.showCheckResultDialog = true
    },
    handleScroll: throttle(function(event) {
      const container = event.target || this.$refs.scrollContainer
      if (!container) return
      if (container.scrollTop >= 160) {
        this.$set(this.heightAttr, 'height', 'calc(100vh - 115px)')
      } else {
        this.heightAttr = {}
      }
    }),
    computedDate (date) {
      if (date) {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
      }
      return '--'
    },
    filterReportStatus (status) {
      if (status == 1) {
        return '<span style="color: #1990FF;">已跟单</span>'
      } else if (status == 2) {
        return '<span style="color: #FF9F19;">已丢单</span>'
      } else if (status == 3) {
        return '<span style="color: #40D822;">已返款</span>'
      }
      
      return '<span style="color: #8F8F8F; font-size: 12px;">报单状态更新存在延迟，请稍等5min后刷新页面再试</span>'
    },
    computedRebatePromotionAmount (row) {
      // 佣金 promotionAmount+补贴佣金 promotionAmount
      return moneyFormatFn((row.rebatePromotionAmount || 0) + (row.promotionAmount || 0))
    },
    batchDelHandler () {
      const ids = this.multipleSelection.map(item => item.thirdOrderSn)
      this.$confirm(`选中${this.multipleSelection.length}条数据，确定删除选中的数据吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeOrderReportWeb.call(this, ids).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.multipleSelection = []
          this.goSearch()
        })
        // let list = []
        // ids.forEach(id => {
        //   list.push(delKlLiveRoomProduct.call(this, {
        //     liveRoomId: id
        //   }))
        // })
        // Promise.all(list).then(() => {
        //   this.$message({
        //     type: 'success',
        //     message: '删除成功'
        //   })
        //   this.multipleSelection = []
        //   this.goSearch()
        // })
      })
    },
    goSearch () {
      this.pageInfo.current = 1
      this.getList()
      // 汇总数据
      this.queryOrderReportSum()
    },
    oneQdChange (val) {
      this.form.qdAccountId = ''
      this.getAccountList(val)
      this.goSearch()
    },
    async getAllList() {
      this.downloadLoading = true
      const pageSize = 500
      const pages = Math.ceil(this.pageInfo.total / pageSize)
      const list = []
      const params = this.getParams()
      if (pages >= 0) {
        for (let i = 0; i < pages; i++) {
          list.push(queryExportOrderReportWeb.call(this, {
            pageIndex: i + 1,
            pageSize: pageSize,
            reportTypeList: ['ZS'],
            ...params
          }))
        }
      }
      const data = await Promise.all(list)
      if (data.length) {
        const allList = []
        data.forEach(item => {
          allList.push(...(item.records || []))
        })
        this.allList = allList
        this.downloadExcel()
      }
    },
    // 导出
    downloadExcel() {
      const heads = []
      const baseKeys = []
      this.fields.forEach(item => {
        if (typeof item.needExport === 'undefined' || (typeof item.needExport === 'function' && item.needExport())) {
          heads.push(item.label)
          baseKeys.push(item.key)
        }
      })
      
      const data = [
        [...heads]
      ]

      this.allList.forEach(item => {
        const values = []
        this.fields.forEach(field => { 
          if (typeof item.needExport === 'undefined' || (typeof item.needExport === 'function' && item.needExport())) {
            let val = item[field.key] || ''
            if (field.format) {
              val = field.format(item)
            }
            values.push(item.type === 'number' ? { t: 's', v: val } : val)
          }
        })

        data.push(values)
      })

      this.downloadLoading = false
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data)

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

      // 使用blob和FileReader创建一个URL然后下载
      const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
      // 
      saveAs(dataBlob, `报单列表 ${dayjs().format('YYYYMMDDHHmmss')}.xlsx`)
    },
    showAddReportHandler () {
      this.showAddReportDialog = true
    },
    selectableRow (row) {
      let key = ''
      if (this.roleType == 1) {
        key = 'qdReportStatus'
      } else if (this.roleType == 3) {
        key = 'qdSubReportStatus'
      } else if (this.roleType == 2) {
        key = 'clientReportStatus'
      }

      // idsAids
      // 只有跟单可以选
      //超管，全部可以选
      return this.roleType == 1 ? true : row[key] == 1
    },
    showBatchDialogHandler () {
      this.showBatchDialog = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getAccountRoleType () {
      getAccountRoleType.call(this, {
        accountId: getUserId() // getUserId()
      }).then(res => {
        if (res) {
          this.roleType = res
          // 获取账号列表
          this.getAccountList()
        }
      })
    },
    getAccountList (parentId) {
      // 超管 - 查看所有一级 1
      if (this.roleType == 1) {
        // one=1 就是 一渠道
        // 0就是二级
        douyinM2SPageList.call(this, {
          one: 1,
          current: 1,
          size: 1000
        }).then(res => {
          this.groupList1 = res.records || []
        })
      }
      // 一级 查看二级列表
      if (this.roleType == 3 || parentId) { 
        let opt = {
          one: 0, // 二级
          current: 1,
          size: 1000,
          parentId: getUserId()
        }
        if (parentId) {
          opt.parentId = parentId
        }
        douyinM2SPageList.call(this, opt).then(res => {
          this.groupList2 = res.records || []
        })
      }
    },
    queryOrderReportSum () {
      this.showReportSum = false
      let params = this.getParams()
      queryOrderReportSum.call(this, {
        ...params,
        rebateConfirmStatus: 0,
        reportTypeList: ['ZS', 'QD', 'BT'],
        accountId: getUserId() // 登录账号
      }).then((res) => {
        this.summaryData = {...(res || {})}
        this.showReportSum = true
      })
    },
    getParams () {
      let form = JSON.parse(JSON.stringify(this.form))
      // 报单时间
      if (form.reportDate.length) {
        form.reportDateBegin = form.reportDate[0]
        form.reportDateEnd = moment(form.reportDate[1])
      }
      delete form.reportDate
      // 支付时间
      if (form.orderPayTime && form.orderPayTime.length) {
        form.orderPayTimeBegin = form.orderPayTime[0]
        form.orderPayTimeEnd = moment(form.orderPayTime[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      delete form.orderPayTime
      // 收货时间
      if (form.orderReceiveTime && form.orderReceiveTime.length) {
        form.orderReceiveTimeBegin = form.orderReceiveTime[0]
        form.orderReceiveTimeEnd = moment(form.orderReceiveTime[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      delete form.orderReceiveTime

      // 角色：1-超管 2-二级渠道 3-一级渠道 
      if (form.reportStatus) {
        switch (this.roleType) {
          case 1:
            form.qdReportStatus = form.reportStatus
            break
          case 2:
            form.clientReportStatus = form.reportStatus
            break
          case 3:
            form.qdSubReportStatus = form.reportStatus
            break
        }
      }
      delete form.reportStatus

      // 佣金
      if (form.incomeStatus !== '') {
        switch (this.roleType) {
          // case 1:
          //   form.qdCommissionIncomeStatus = form.incomeStatus
          //   break
          case 2:
            form.qdSubCommissionIncomeStatus = form.incomeStatus
            break
          case 3:
            form.qdCommissionIncomeStatus = form.incomeStatus
            break
        }
      }
      delete form.incomeStatus
      
      form.accountId = getUserId() // 登录账号

      let rst = {}
      for (let key in form) {
        if (form[key] !== '' && form[key] !== null && form[key] !== undefined) {
          rst[key] = form[key]
        }
      }
      // 订单编号，多个
      if (form.thirdOrderSn) {
        rst.thirdOrderSnList = form.thirdOrderSn.split('\n').map(item => item.trim()).filter(item => !!item)
        delete rst.thirdOrderSn
      }

      return rst
    },
    getList () { 
      this.isLoading = true
      this.tableData = []
      let params = this.getParams()

      queryExportOrderReportWeb.call(this, {
        ...params,
        reportTypeList: ['ZS', 'QD', 'BT'],
        rebateConfirmStatus: 0,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }).then((res) => {
        const {records, pages, total} = res
        this.pageInfo.total = total || 0
        this.pageInfo.pages = pages || 0
        this.tableData = [...(records || [])]
      }).finally(() => {
        this.isLoading = false
      })
    },
    // 新增、修改回调
    successHandler () {
      this.showBatchDialog = false
      this.multipleSelection = []
      this.$refs.multipleTable.clearSelection()
      this.getList()
    },
    showAddResultDialogHandler (rst) {
      this.showAddReportDialog = false
      this.importResult = rst
      this.showAddResultDialog = true
      // this.getList()
    },
    showImportExportDialogHandler () {

    },
    addReportSuccessHandler() {
      this.showAddResultDialog = false
      this.getList()
    }
  }
}
</script>
<style scoped>
.search-box .flex-row {
  padding-bottom: 8px;
}
.search-box .flex-row:last-child {
  padding-bottom: 0;
}
.summary-line {
  height: auto;
  overflow: hidden;
  font-size: 14px;
  line-height: 28px;
  color: #666; 
} 
.table-cell {
  display: flex;
  flex-direction: column;
}
.table-cell .table-line {
  padding: 0 10px;
  box-sizing: border-box;
  height: 22px;
  line-height: 22px;
  white-space: nowrap;      /* 强制文本不换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 溢出时显示省略号 */
  width: 100%;  
  border-bottom: 1px solid #E9EDF7;
}
.table-cell .table-line.title {
  color: #909399;
  font-weight: 500;
}
.table-cell .table-line:last-child {
  border-bottom: none;
}
.el-table.y-table td {
  padding: 0 !important;
}
.red-bg {
  color: #fff !important;
  background-color: #FF9B9B;
}
.bd--pag {
  background: #fff;
  position: sticky;
  bottom: 0;
  margin-top: 0;
  padding: 10px 0;
  z-index: 9;
}
.shadow-box {
  box-shadow: none;
  border-radius: none;
  padding: 0 12px;
}

.y-table.el-table ::v-deep .el-table__header-wrapper {
  position: sticky;
  z-index: 99;
  top: 0;
}

.text1 {
  font-weight: 500;
  font-size: 12px;
  color: #8F8F8F;
}
.status-text {
  color: #555;
  font-weight: 500;
  font-size: 14px;
}
.search-item {
  margin-right: 0;
}
.page {
  height: calc(100vh - 62px);
  overflow: scroll;
}
</style>
